<script setup lang="ts">
/** Two states, one drawing: the cone is always there, the waves or the
 *  slash swap for it — the same "one icon component, a prop picks the
 *  variant" shape `GearIcon.vue` uses. */
withDefaults(defineProps<{ muted?: boolean }>(), { muted: false });
</script>

<template>
  <svg class="speaker-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M11 5 6 9H2v6h4l5 4V5Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linejoin="round"
    />
    <g v-if="!muted" class="waves" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
      <path d="M15.5 8.5a5 5 0 0 1 0 7" />
      <path d="M18.6 5.4a9.5 9.5 0 0 1 0 13.2" />
    </g>
    <path
      v-else
      class="slash"
      d="M22.5 9 16.5 15M16.5 9l6 6"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<style scoped>
.speaker-icon {
  flex: none;
  display: block;
}
</style>
